export enum BoardResolutionKey {
  SQUARE = '1:1',
  PORTRAIT_9_16 = '9:16',
}

export interface BoardResolution {
  key: BoardResolutionKey;
  label: string;
  width: number;
  height: number;
}

export const BOARD_RESOLUTIONS: Record<BoardResolutionKey, BoardResolution> = {
  [BoardResolutionKey.SQUARE]: {
    key: BoardResolutionKey.SQUARE,
    label: '1:1 (1080×1080)',
    width: 1080,
    height: 1080,
  },
  [BoardResolutionKey.PORTRAIT_9_16]: {
    key: BoardResolutionKey.PORTRAIT_9_16,
    label: '9:16 (720×1280)',
    width: 720,
    height: 1280,
  },
};

export const BOARD_RESOLUTION_LIST: BoardResolution[] = Object.values(BOARD_RESOLUTIONS);

export const DEFAULT_BOARD_RESOLUTION = BOARD_RESOLUTIONS[BoardResolutionKey.SQUARE];

export const resolveBoardResolution = (width: number, height: number): BoardResolution =>
  BOARD_RESOLUTION_LIST.find((r) => r.width === width && r.height === height) ?? DEFAULT_BOARD_RESOLUTION;
